import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import type { IWohaMediaProps } from "./WohaMedia.props";
const ratios = {
  "1:1": "aspect-square",
  "4:3": "aspect-4/3",
  "3:2": "aspect-3/2",
  "16:9": "aspect-video",
  "21:9": "aspect-21/9",
  "3:4": "aspect-3/4",
  "2:3": "aspect-2/3",
} as const;
export const WohaMedia = ({
  aspectRatio,
  className,
  imageClassName,
  media,
  priority,
  sizes,
}: IWohaMediaProps) => {
  const Image = getComponent("Image");
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-xl bg-paper-mist",
        aspectRatio ? ratios[aspectRatio] : undefined,
        className,
      )}
    >
      <Image
        alt={media.alternateText}
        className="h-full w-full"
        height={media.height || undefined}
        imageClassName={cn(
          "h-full w-full",
          aspectRatio ? "object-cover" : "object-contain",
          imageClassName,
        )}
        priority={priority}
        sizes={sizes}
        src={media.defaultSrc}
        srcSet={media.srcSet || undefined}
        width={media.width || undefined}
      />
    </div>
  );
};
WohaMedia.displayName = "Content::WohaMedia";
